'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { default as MonacoEditor } from '@monaco-editor/react';
import { useTheme } from 'next-themes';
import { useEffect, useRef } from 'react';
import githubDark from './github-dark.json';
import githubLight from './github-light.json';
export function Editor(_a) {
    var { selection, editable, jsonSchemas } = _a, props = __rest(_a, ["selection", "editable", "jsonSchemas"]);
    const monacoRef = useRef(null); // see https://github.com/suren-atoyan/monaco-react/issues/250
    const editorRef = useRef(null);
    useEffect(() => {
        if (!monacoRef.current || !editorRef.current) {
            return;
        }
        if (!selection) {
            return;
        }
        const { start, end } = selection;
        editorRef.current.setSelection(new monacoRef.current.Selection(start.line, start.column, end.line, end.column));
        editorRef.current.revealRangeInCenter(new monacoRef.current.Range(start.line, start.column, end.line, end.column));
        editorRef.current.focus();
    }, [monacoRef.current, editorRef.current, selection]);
    useEffect(() => {
        if (!monacoRef.current) {
            return;
        }
        monacoRef.current.languages.json.jsonDefaults.setDiagnosticsOptions({
            validate: true,
            schemas: jsonSchemas
        });
    }, [monacoRef.current, jsonSchemas]);
    let { resolvedTheme } = useTheme();
    return (_jsx(_Fragment, { children: _jsx(MonacoEditor, Object.assign({ theme: resolvedTheme === 'dark' ? 'github-dark' : 'github-light', beforeMount: (monaco) => {
                monacoRef.current = monaco;
                monaco.editor.defineTheme('github-light', githubLight);
                monaco.editor.defineTheme('github-dark', githubDark);
                if (jsonSchemas) {
                    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                        validate: true,
                        schemas: jsonSchemas
                    });
                }
            }, onMount: (editor, monaco) => {
                editorRef.current = editor;
            }, options: {
                automaticLayout: true,
                readOnly: editable !== true,
                minimap: {
                    enabled: false
                },
                hover: {},
                fixedOverflowWidgets: true
            } }, props)) }));
}
